import { autoinject } from "aurelia-framework";

import { IdentityClient } from "../infrastructure/identity-client";
const ssoReturnUrlKey: string = "ssoReturnUrlAfterSignIn";
const ssoTypeKey: string = "ssoTypeKey";

@autoinject
export class ExternalAuthService {
  private _client: IdentityClient;

  public constructor(client: IdentityClient) {
    this._client = client;
  }

  public clear() {
    window.sessionStorage.removeItem(ssoReturnUrlKey);
    window.sessionStorage.removeItem(ssoTypeKey);
  }

  public getSsoReturnUrl() {
    return window.sessionStorage.getItem(ssoReturnUrlKey);
  }

  public setSsoReturnUrl(returnUrl: string) {
    window.sessionStorage.setItem(ssoReturnUrlKey, returnUrl);
  }

  public getSsoType() {
    return window.sessionStorage.getItem(ssoTypeKey);
  }

  public setSsoType(typeKey: string) {
    window.sessionStorage.setItem(ssoTypeKey, typeKey);
  }
}
